import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import {  Spin } from "antd";

const SedBranches = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");

  const { userPermissions, webApi } = useUserPermissions();

  const [isLoading, setIsLoading] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState<string>("");
  const [pageSize, setPageSize] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [totalCount, setTotalCount] = useState(0);
  const [searchText, setSearchText] = useState<string>("");
  const [data, setData] = useState<any[]>([]);


  const FILTERS = [
    { label: "All", value: "" },
    { label: "SCTS", value: "1" },
    { label: "ETS", value: "2" },
  ];

  //  Fetch the agent Reports
  const fetchData = async (
    pageNumber: number,
    searchQuery: string,
  ) => {
    setIsLoading(true)
    try {
      const res = await fetch(
        `${webApi}/sed/branch_wise_sale_report/?building_category=${selectedFilter}&page=${pageNumber}&search=${searchQuery}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        },
      );
      if (!res.ok) {
        const errorData = await res.json();
        if (errorData.code === "token_not_valid") {
          navigate("/academic/sri-chaitanya/crm/landing-page");
        }
        throw new Error(errorData.detail || "Failed to fetch user data");
      }
      const json = await res.json();
      setData(json.results);
      setCurrentPage(json.current_page_number)
      setTotalCount(json.total_count)
    } catch (error) {
      console.log("Error:", error);
    }finally{
        setIsLoading(false)
    }
  };

  useEffect(()=>{
    fetchData(currentPage, searchText);
  },[searchText, selectedFilter, pageSize, currentPage ])

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  const columns = [
    {
      title: "Branch",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Total Sales",
      dataIndex: "total_sales",
      key: "total_sales",
    },
    {
      title: "Total Students",
      dataIndex: "total_students",
      key: "total_students",
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">SED Branches </h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.SEDDashBoard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Branches
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* <div className="mb-2">
                {checkPermission("add", "summercamppriority") && (
                  <Link to={routes.SummerCampAddPriorities} className="btn btn-primary">
                    <i className="ti ti-square-rounded-plus-filled me-2" />
                    Add Priority
                  </Link>
                )}
              </div> */}
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Branches List</h4>
              <div>
                <div className="d-flex gap-2 flex-wrap">
                  {FILTERS.map((filter) => {
                    const isActive = selectedFilter === filter.value;

                    return (
                      <button
                        key={filter.value || "all"}
                        onClick={() => setSelectedFilter(filter.value)}
                        className={`btn ${isActive ? "btn-primary" : "btn-outline-secondary"}`}
                      >
                        {filter.label}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={data}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    total: totalCount,
                    showTotal: (total: any, range: any[]) =>
                      `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: ["10", "25", "100", "500", "1000"],
                  }}
                  onChange={handleTableChange} // Move this outside of pagination
                  onSearch={handleSearch}
                  searchText={searchText}
                />
              )}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
    </div>
  );
};

export default SedBranches;
